import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'archives-rdc-filters';

export const FETCH_FILTERS = createApiConstants(NAMESPACE, 'FETCH_FILTERS');
export const GET_USERS = createApiConstants(NAMESPACE, 'GET_USERS');
export const GET_TEAMS = createApiConstants(NAMESPACE, 'GET_TEAMS');
export const CHANGE_PAGE = `${NAMESPACE}/CHANGE_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;
export const UPDATE_QUERY = `${NAMESPACE}/UPDATE_QUERY`;
export const UPDATE_FILTER = `${NAMESPACE}/UPDATE_FILTER`;
export const CHANGE_URL_QUERY_TO_FILTERS = `${NAMESPACE}/CHANGE_URL_QUERY_TO_FILTERS`;
